export default {
      id: "i-service-stockmap-usage",
      viewBox: "0 0 157 135",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-stockmap",
      toString: function () {
        return this.url;
      }
    }